/*
 * Identity providers supported in Auth0 for user authentication
 */
export enum IdentityProvider {
  GOOGLE_OAUTH2 = 'google-oauth2',
  USER_PASSWORD = 'auth0',
}
